// theme/components/QuantityPicker.js
export default {
    baseStyle: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    },
    variants: {
        round: {
            container: {
                bg: 'white',
                border: '2px solid',
                borderColor: 'darkGray',
                borderRadius: '33px',
                maxW: {base: '100%', sm: '140px'},
                h: '48px',
                _hover: {borderColor: 'black'}
            },
            button: {
                border: 0,
                fontSize: '2xl',
                color: 'black'
            },
            input: {
                border: 0,
                fontSize: 'xl',
                minW: '40px',
                h: '38px',
                p: 0,
                textAlign: 'center',
                _focusVisible: {boxShadow: 'unset !important'}
            }
        },
        circle: {
            container: {
                spacing: 0,
                w: '84px',
                _hover: {borderColor: 'black'}
            },
            button: {
                border: 0,
                fontSize: '21px',
                color: 'black',
                borderRadius: 'full',
                background: 'white',
                boxShadow: '0 2px 4px 0 rgba(0,0,0,0.20)',
                minWidth: 'unset',
                h: '28px !important',
                w: '28px',
                p: 2,
                _disabled: {
                    opacity: 1,
                    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.20)'
                }
            },
            input: {
                border: 0,
                fontSize: 'md',
                h: '28px',
                w: '28px',
                p: 0,
                textAlign: 'center',
                background: 'unset !important',
                _focusVisible: {boxShadow: 'unset !important'}
            }
        }
    },
    defaultProps: {
        variant: 'round'
    }
}
